import * as React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import { io, Socket } from "socket.io-client";

import { SocketContext } from "../../../socket";
import LotteryListRenderer from "./LotteryListRenderer";

const LotteryListGetter: React.FC<{}> = () => {
  //@ts-ignore
  const config = window.config;
  const apiBaseURL = config?.server || "http://18.217.95.31:8080";
  const { t } = useTranslation("translation");
  const navigate = useNavigate();
  // const socket = React.useContext(SocketContext);
  const [data, setData] = React.useState<Array<any>>([]);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [totalCount, setTotalCount] = React.useState<number>(0);
  const [socket, setSocket] = React.useState<any>();

  // const socket = io(apiBaseURL, {
  //   autoConnect: false,
  //   query: {
  //     userId: JSON.parse(localStorage.getItem("UserData") || "")?.uId,
  //   },
  // });

  let localData = localStorage?.getItem("UserData");
  if(!localData) {
    localStorage.clear();
    navigate("/login")
  }
  const auth = localData ? JSON.parse(localStorage.getItem("UserData") || "") : null;
  const screen = localStorage.getItem("screenNumber");
  const screenNumberDetails = screen
    ? JSON.parse(localStorage.getItem("screenNumber") || "")
    : null;

  React.useEffect(() => {
    setLoading(true);
    // socket.connect();
    const establishedEvent = io(apiBaseURL, {
      autoConnect: true,
      query: {
        userId: JSON.parse(localStorage.getItem("UserData") || "")?.uId,
      },
    });
    setSocket(establishedEvent);

    //Update screen number with dynamic data, once you get settings API
    axios
      .get(
        `${apiBaseURL}/api/ticket/fetchShopBasedLinkedTickets?shopId=${auth?.uId}&screenNumber=${screenNumberDetails}`,
      )
      .then((res: any) => {
        const updatedData: any = [];
        res?.data?.linkedTickets?.map((data: any, index: any) => {
          updatedData[data?.ticketPosition] = data;
        });
        setData(updatedData);
      })
      .catch((error: Error) => {
        console.log("err", error);
      })
      .finally(() => setLoading(false));

    return () => {
      socket && socket.disconnect();
    };
  }, []);

  React.useEffect(() => {
    socket && socket.once("fetchTicketByNumberResponse", (response: any) => {
      if (response?.message || response?.error) {
        return null;
      } else {
        const updatedData = [...data];
        if(screenNumberDetails == response?.screenNumber) {
          updatedData[response.ticketPosition] = {
            ...response.ticket,
            ...{ linkedId: response?.linkedId, screenNumber: response?.screenNumber },
          };
        }
        setData(updatedData);
      }
    });

    socket && socket.once("deleteLinkedTicketResponse", (response: any) => {
      const updatedData = [...data];
      if(screenNumberDetails == response?.screenNumber) {
        updatedData[response.ticketPosition] = {}
      }
      setData(updatedData);
    });

    socket && socket.once("updateLinkedTicketResponse", (response: any) => {
      const updatedData = [...data];
      if(screenNumberDetails == response?.screenNumber) {
        updatedData[response.ticketPosition] = {
          ...updatedData[response.ticketPosition],
          isAnimate: response.ticket?.[0].isAnimate ?? updatedData[response.ticketPosition].isAnimate,
          isNew: response.ticket?.[0].isNew ?? updatedData[response.ticketPosition].isNew,
          isSoldOut: response.ticket?.[0].isSoldOut ?? updatedData[response.ticketPosition].isSoldOut,
          isWinner: response.ticket?.[0].isWinner ?? updatedData[response.ticketPosition].isWinner,
          prizeMoney: response.ticket?.[0].prizeMoney ?? updatedData[response.ticketPosition].prizeMoney
        };
      }
      setData(updatedData);
    });

    return () => {
      socket && socket.off("fetchTicketByNumberResponse");
      socket && socket.off("deleteLinkedTicketResponse");
      socket && socket.off("updateLinkedTicketResponse");
    };
  }, [socket, data]);

  return <LotteryListRenderer data={data} loading={loading} count={totalCount} />;
};
export default LotteryListGetter;
